import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AddonStatus, GlobalTravelPassLineStatus } from 'my-account/constants';
import { GlobalTravelPassTab } from 'store/global-travel-pass/models/global-travel-pass';
import { MyAccountModal } from 'my-account/services/modal';
import { XmCancelRemovalModal } from '../modals/cancel-removal/cancel-removal';
import { GlobalTravelPassLine } from 'store/global-travel-pass/models';
import { XmAddAdditionalDataModal } from '../modals/add-additional-data/add-additional-data';
import { IXMOptions } from 'core/interfaces';
import { CONFIG_TOKEN } from 'core/constants';
import { CimaCore } from 'services/cima/core';

export interface GtpLineOptionClick {
    option: string;
    phoneNumber: string;
    lineId?: string;
}

@Component({
    selector: 'xm-gtp-card',
    templateUrl: './gtp-card.html',
    styleUrls: ['./gtp-card.scss'],
    standalone: false
})
export class XmGtpCardComponent implements OnInit {
    @Input() public tab: GlobalTravelPassTab;

    @Input() public ctaLabel: string = '';
    @Input() public displayPrice?: string;
    @Input() public showActiveIcon: boolean = false;
    @Input() public inUseIcon?: MediaImageOptions;
    @Input() public mediaImageOptions?: MediaImageOptions;
    @Input() public imageUrl?: string = '';
    @Input() public isGtp: boolean = false;
    @Input() public isInternational: boolean = false;

    @Output() public addGlobalTravelPassClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() public searchTravelRatesClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() public optionBtnClick: EventEmitter<GtpLineOptionClick> = new EventEmitter<GtpLineOptionClick>();

    public get isInactive(): boolean {
        return this.tab.lines && this.tab.lines.length === 0;
    }

    public badgeStatusOff: string = GlobalTravelPassLineStatus.OFF;
    public badgeStatusPendingRemoval: string = GlobalTravelPassLineStatus.PENDING_REMOVAL;
    public inactiveStatus: string = AddonStatus.INACTIVE;
    public isGtpIteration2: boolean = false;
    public isCBMInternationalReteLinkEnabled: boolean = false;

    private accountModal: MyAccountModal;
    private config: IXMOptions;
    private cimaCore: CimaCore;

    constructor(accountModal: MyAccountModal, @Inject(CONFIG_TOKEN) config: IXMOptions, cimaCore: CimaCore) {
        Object.assign(this, { accountModal, config, cimaCore });
    }

    public ngOnInit(): void {
        this.isGtpIteration2 = this.config.ENABLE_GTP_ITERATION_2;
        this.isCBMInternationalReteLinkEnabled = this.config.ENABLE_CBM_INTERNATIONAL_RETE_LINK || !this.cimaCore.isBusinessUser;
    }
    
    public onAddGlobalTravelPassClick(): void {
        this.addGlobalTravelPassClick.emit();
    }

    public onSearchTravelRatesClick(): void {
        this.searchTravelRatesClick.emit();
    }

    public onOptionBtnClick(data: GtpLineOptionClick): void {
        this.optionBtnClick.emit(data);
    }

    public onCancelRemovalClick(line: GlobalTravelPassLine): void {
        this.accountModal.open(XmCancelRemovalModal, {
            lineId: line.lineIdKey,
            removalRequestCode: line.removalRequestCode,
            isGtp: this.isGtp
        });
    }

    public onAddAdditionalDataClick(line: GlobalTravelPassLine): void {
        this.accountModal.open(XmAddAdditionalDataModal, {
            lineId: line.lineIdKey,
            isGtp: this.isGtp
        });
    }
}
